<template>
  <div class="pic_bg">
    <header>
      <el-image :src="iconHeader"></el-image>
      <span class="title_font">{{ titleName }}</span>
    </header>
    <body>
      <!-- <div v-for="(item, index) in list" style="margin:10px 0;cursor: pointer;">
        <p>{{item.createTime + ' ' + item.broweTypename}}</p>
      </div> -->
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="broweUser"
          label="用户">
        </el-table-column>
        <el-table-column
          prop="broweTypename"
          label="类型">
        </el-table-column>
        <el-table-column
          prop="broweContentName"
          label="名称">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="访问时间">
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </body>
  </div>
</template>

<script>
import { getBrowerecord } from "@/network/api";
export default {
  data() {
    return {
      titleName: '历史记录',
      iconHeader: require("@/assets/images/pageico_4.png"),
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.queryHistory()
    },
    queryHistory() {
      getBrowerecord({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.queryHistory()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryHistory()
    }
  }
}
</script>

<style scoped>
.pic_bg {
  width: 1150px;
  margin: 0 auto;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  width: 1150px;
  margin-top: 12px;
  margin-bottom: 12px;
  min-height: 100px;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
  cursor: pointer;
}
.btn-h:hover {
  cursor: pointer;
}
.page {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/HistoryRecord.vue